import base64 from 'base-64';

export const SOL_FIELD = "sol_i";
export const IMG_SRC_FIELD = "img_src_t";
export const EARTH_DATE_FIELD = "earth_date_dt";
export const CAMERA_SHORT_FIELD = "camera_short_t";
export const CAMERA_NAME_FIELD = "camera_name_t";
export const ROVER_NAME_FIELD = "rover_name_t";
export const ROVER_LANDING_FIELD = "rover_landing_dt";
export const ROVER_LAUNCH_FIELD = "rover_launch_dt";
export const ROVER_STATUS_FIELD = "rover_status_t";
export const ROVER_LAST_DATE_FIELD = "rover_last_date_dt";
export const ROVER_LAST_SOL_FIELD = "rover_last_sol_i";
export const ROVER_PHOTOS_FIELD = "rover_photos_i";


class Searcher {

  constructor() {
    this.baseURL = process.env.REACT_APP_SOLR_URL;
    this.username = process.env.REACT_APP_SOLR_USERNAME;
    this.password = process.env.REACT_APP_SOLR_PASSWORD;

    this.config = {
      // todo fill in default query
      params: {
        fl: "*,score",
        sort: `${SOL_FIELD} ASC, ${ROVER_NAME_FIELD} ASC`,
        fq: []
      },

      query: {
        edismax: {
          qf: `${ROVER_NAME_FIELD}^25 ${EARTH_DATE_FIELD}^20 ${SOL_FIELD}^15 ${CAMERA_NAME_FIELD}^10 ${ROVER_STATUS_FIELD}^3 ${CAMERA_SHORT_FIELD}^15 ${ROVER_LANDING_FIELD}^1 ${ROVER_LAUNCH_FIELD}^1 ${ROVER_LAST_DATE_FIELD}^1 ${ROVER_LAST_SOL_FIELD}^1 ${ROVER_PHOTOS_FIELD}^1`,
          mm: "100%",
        },
      },

    }
  }

  updateSearchString(searchString) {
    if (searchString && searchString !== '') {
      this.config.query.edismax.query = `${searchString.split(' ').join(' AND ')}`;
    } else {
      this.config.query.edismax.query = '*:*';
    }
  }

  updateEarthDate(fromDate, toDate) {
    if (this.config.params.fq) {
      this.config.params.fq = this.config.params.fq.filter((field) => !field.startsWith(EARTH_DATE_FIELD));
    }
    if (fromDate && toDate) {
      this.config.params.fq.push(
        `${EARTH_DATE_FIELD}:[${fromDate.toISOString()} TO ${toDate.toISOString()}]`
      )
    }
  }

  updateSol(fromSol, toSol) {
    if (this.config.params.fq) {
      this.config.params.fq = this.config.params.fq.filter((field) => !field.startsWith(SOL_FIELD));
    }
    if (fromSol && toSol) {
      this.config.params.fq.push(
        `${SOL_FIELD}:[${fromSol} TO ${toSol}]`
      )
    }
  }

  updateRovers(rovers) {
    if (this.config.params.fq) {
      this.config.params.fq = this.config.params.fq.filter((field) => !field.startsWith(ROVER_NAME_FIELD));
    }
    
    if (rovers && rovers.length > 0) {
      this.config.params.fq.push(
        `${ROVER_NAME_FIELD}:(${rovers.join(' OR ')})`
      );
    }
  }

  updateFilter(filter) {
    this.updateSearchString(filter.searchString);
    this.updateEarthDate(filter.fromDate, filter.toDate);
    this.updateSol(filter.fromSol, filter.toSol);
    this.updateRovers(filter.rovers);
  }

  async spellCheck(name) {
    const response = await fetch(`/.netlify/functions/spellcheck?q=${name}`);

    const content = await response.json();
    if (content.spellcheck) {
      return content.spellcheck.suggestions;
    }

    return [];
  }

  async search(start, end) {
    this.config.params.start = start;
    this.config.params.rows = end;
    const response = await fetch(`/.netlify/functions/search`, {
      method: 'POST',
      body: JSON.stringify(this.config)
    });

    return response.json();
  }
}

export default new Searcher();